$('.masthead__menu .menu a[target*="blank"]').prepend('<i class="icon-left fas fa-xs fa-external-link"></i>&nbsp;');
$('.site-footer__nav .menu a[target*="blank"]').prepend('<i class="icon-left fas fa-xs fa-external-link"></i>&nbsp;');
